import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, MessageSquare } from 'lucide-react';
import { API } from '@/lib/api';
import { authHeaders, apiError } from '@/admin/AdminContentContext';

export default function ChatLogs() {
  const [sessions, setSessions] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);

  const load = () => axios.get(`${API}/admin/chats`, authHeaders()).then(({ data }) => setSessions(data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const openSession = async (id) => {
    setActive(id);
    const { data } = await axios.get(`${API}/admin/chats/${id}`, authHeaders());
    setMsgs(data);
  };
  const remove = async (id) => {
    if (!window.confirm('حذف هذه المحادثة؟')) return;
    await axios.delete(`${API}/admin/chats/${id}`, authHeaders());
    if (active === id) { setActive(null); setMsgs([]); }
    load();
  };

  return (
    <section className="mt-5 rounded-3xl border border-brand-line bg-white p-6" data-testid="chat-logs">
      <h3 className="font-display text-base font-extrabold text-brand-ink">محادثات الزوار مع المساعد</h3>
      <p className="mt-1 text-xs text-brand-steel">راجع ما يسأله الزوار لتحسين تعليمات المساعد أعلاه. يتعلّم المساعد تلقائياً من المحتوى <b>المنشور</b> — انشر المحتوى بعد أي تعديل ليعرفه.</p>
      <div className="mt-4 grid gap-4 lg:grid-cols-3">
        <ul className="max-h-96 divide-y divide-brand-line overflow-y-auto rounded-2xl border border-brand-line" data-lenis-prevent data-testid="chat-sessions">
          {sessions.length === 0 && <li className="px-4 py-10 text-center text-xs text-brand-dim" data-testid="chat-sessions-empty">لا توجد محادثات بعد.</li>}
          {sessions.map((s, i) => (
            <li key={s.session_id} className={`flex items-center gap-2 px-3 py-2.5 ${active === s.session_id ? 'bg-brand-blue/5' : ''}`} data-testid={`chat-session-${i}`}>
              <button type="button" onClick={() => openSession(s.session_id)} className="min-w-0 flex-1 text-start">
                <p className="truncate text-xs font-bold text-brand-ink">{s.first_message}</p>
                <p className="font-mono text-[10px] text-brand-dim" dir="ltr">{new Date(s.last_at).toLocaleString('en-GB')} · {s.count} msgs · {s.lang}</p>
              </button>
              <button type="button" onClick={() => remove(s.session_id)} data-testid={`chat-session-delete-${i}`} className="grid h-7 w-7 place-items-center rounded-lg text-brand-dim hover:text-brand-crimson"><Trash2 className="h-3.5 w-3.5" /></button>
            </li>
          ))}
        </ul>
        <div className="max-h-96 space-y-2 overflow-y-auto rounded-2xl border border-brand-line bg-brand-paper p-4 lg:col-span-2" data-lenis-prevent data-testid="chat-transcript">
          {!active && <p className="grid h-full place-items-center text-xs text-brand-dim"><span className="inline-flex items-center gap-2"><MessageSquare className="h-4 w-4" /> اختر محادثة لعرضها</span></p>}
          {msgs.map((m) => (
            <div key={m.id} className={`flex ${m.role === 'user' ? 'justify-start' : 'justify-end'}`}>
              <div className={`max-w-[85%] whitespace-pre-wrap rounded-2xl px-3.5 py-2 text-xs leading-relaxed ${m.role === 'user' ? 'bg-white text-brand-ink' : 'bg-brand-blue text-white'}`}>{m.content}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
